import axios, { AxiosInstance } from 'axios';
import config from '../config';
import { getAuthToken, setupAuthInterceptor } from '../utils';
import { History } from 'history';

export const configureProfileService = (service: AxiosInstance) => {
  service.interceptors.request.use(
    async (config) => {
      const token = await getAuthToken();
      if (token) {
        config.headers = config.headers || {
          'Access-Control-Allow-Methods': 'GET, HEAD, POST, PUT, DELETE, OPTIONS',
        };
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    },
  );
};

export const createProfileService = (history?: History): AxiosInstance => {
  const profileService = axios.create({
    baseURL: config.profileServiceURL,
  });

  setupAuthInterceptor(profileService, history);

  return profileService;
};

const profileService = createProfileService();

configureProfileService(profileService);
export { profileService };
